//export const HOST = 'https://www.rapi-fruti.com';
//export const HOST = 'http://192.168.1.34:4000';
// By default try to detect the current machine/host at runtime using the browser's
// location (so you don't need to edit this file when your LAN IP changes).
// You can still override the host or port using environment variables:
//  VITE_HOST (full URL, e.g. https://192.168.1.36:4000)
//  VITE_BACKEND_PORT (port only, defaults to 4000)
const backendPort = import.meta.env.VITE_BACKEND_PORT || '4000';

// En local apuntamos al mismo hostname con el puerto del backend.
// En producción (Cloudflare Pages), la API vive en el subdominio api.*.
const localHost =
  typeof window !== 'undefined'
    ? `${window.location.protocol}//${window.location.hostname}:${backendPort}`
    : 'http://localhost:4000';

export const HOST =
  import.meta.env.VITE_API_URL ||
  import.meta.env.VITE_HOST || // compat con el nombre anterior
  (import.meta.env.DEV ? localHost : 'https://api.rapi-fruti.com');

export const ROLE = ['Admin', 'Usuario'];

export enum ORDER_STATUS {
  PENDING = 'Pendiente',
  COMPLETE = 'Finalizado',
  CANCEL = 'Cancelado',
}

export enum ROUTE_NAME_OPTIONS {
  PRODUCTS_LIST = 'lista-productos',
  SHOPPING_CART = 'carrito',
  CREATE_PRODUCT = 'crear-producto',
  USER_INFO = 'mi-informacion',
  ORDERS = 'mis-pedidos',
  LOGIN = 'iniciar-sesion',
  PRICE_LIST = 'lista-precios',
  RESET_PASSWORD = 'restablecer-contrasena',
  FORGOT_PASSWORD = 'olvide-contrasena',
  VERIFY = 'verificar',
  LOGIN_SUCCESS = 'inicio-sesion-exitoso',
  ORDER_CONFIRMATION = 'pedido-confirmado',
}

export const minimumPurchaseAmount = 60000;

export enum TimeSlot {
  MORNING = '09:00-13:00',
  AFTERNOON = '13:00-17:00',
}

export const timeZone = [
  { value: TimeSlot.MORNING, label: '09:00 - 13:00' },
  { value: TimeSlot.AFTERNOON, label: '13:00 - 17:00' },
];

export const cities = [
  { value: 'Quilmes', label: 'Quilmes' },
  { value: 'Bernal', label: 'Bernal' },
  { value: 'Ezpeleta', label: 'Ezpeleta' },
  { value: 'Berazategui', label: 'Berazategui' },
  { value: 'Wilde', label: 'Wilde' },
  { value: 'Sarandi', label: 'Sarandi' },
  { value: 'Avellaneda', label: 'Avellaneda' },
];

export const optionsStatus = [
  { value: ORDER_STATUS.PENDING, label: 'Pendiente' },
  { value: ORDER_STATUS.COMPLETE, label: 'Finalizado' },
  { value: ORDER_STATUS.CANCEL, label: 'Cancelado' },
];

export enum PaymentMethod {
  CASH = 'efectivo',
  MERCADOPAGO = 'mercadopago',
  TRANSFER = 'transferencia',
}

export const mappleIndividualPrice: number = 6300;
